import { useNavigate, useSearchParams } from "react-router-dom";
import { DataStoreReqEndPointLogic } from "../../../../logic/Admin/DataStoreRequest/DataStoreRequestEndPointLogic";
import DataStoreRequestRunQueryDetails from "./DataStoreRequestRunQueryDetails";
import DataStoreRequestRunQueryInfo from "./DataStoreRequestRunQueryInfo";
import DataStoreRequestRunQueryResults from "./DataStoreRequestRunQueryResults";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { setRunQueryLoading } from "../../../../features/dataStoreReqSlice";
import { useEffect } from "react";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

const DataStoreRequestRunQuery = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Add this line
  const urlId = searchParams.get("id") as any;
  const token = useSelector(selectUserToken);
  const dispatch = useDispatch();
  const { runQueryLoading } = useSelector((state: any) => state.dataStoreReq);
  const fetchQueryData = async () => {
    try {
      dispatch(setRunQueryLoading(true));
      await DataStoreReqEndPointLogic.getBizLayerQueryById(
        token,
        dispatch,
        setRunQueryLoading,
        urlId, // use the parameter 'id' directly instead of `editId`
        navigate
      );
    } catch (error) {
      console.error("Error fetching query data:", error);
    } finally {
      dispatch(setRunQueryLoading(false));
    }
  };

  useEffect(() => {
    if (!urlId) return;
    fetchQueryData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {runQueryLoading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <DataStoreRequestRunQueryInfo />
          <DataStoreRequestRunQueryDetails />
          <DataStoreRequestRunQueryResults />
        </>
      )}
    </>
  );
};

export default DataStoreRequestRunQuery;
